import React, { useMemo, useState } from 'react'
import { Modal } from "react-bootstrap";
import SuperSearchList from '../../../../../../../shared/SuperSearch/SuperSearchList';
import { enumUtil } from '../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../utils/ServerDataRequest';
import { convertValsToStrings } from './utils';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import Loader from '../../../../../../../shared/Loader/Loader';
import isNull from '../../../../../../../../utils/NullChecking';
import { EncounterNotesDisplaySettings } from '../../../../../../../../actions/EncounterNotesDisplaySettings';
import { useDispatch } from 'react-redux';
import DropdownValueHandler from '../../../../../../../shared/SuperSearch/DropdownValueHandler';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FindFirstChild } from '../../../../../../../../utils/FindMenuOption';

const NoteDisplaySettings = ({ noteType = 'Other', setIsSettingsOpen: setIsNoteOpened, defaultSelectedItems, setDefaultSelectedItems, searchParam, setSelectedItems: setPrintOutSelectedItems, ...props }) => {
    // const [isNoteOpened, setIsNoteOpened] = useState(false);
    // const { insertPosition= '' } = props;
    // console.log("NoteDisplaySettingsdefaultSelectedItemsdefaultSelectedItems", noteType, defaultSelectedItems, searchParam);
    let dispatch = useDispatch();
    // let IsUserProvider = useSelector(state => state.IsUserProvider);
    let IsEncounterProvider = Boolean(
        searchParam?.SeenBy && ![-1, '-1'].includes(searchParam.SeenBy)
    );
    let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd
    const allEncounterNotesDisplay = useSelector(state => state?.EncounterNotesDisplaySettingsReducer);
    const allEncounterNotesDisplaySetting = useMemo(() => allEncounterNotesDisplay || [], [allEncounterNotesDisplay]);

    let historyofPresentIllnessTypeData = [
        { value: '-1', display: '' },
        { value: 'Both', display: 'Both' },
        { value: 'FreeText', display: 'Free Text' },
        { value: 'Fields', display: 'Fields' },
    ]
    // const DEFAULT_SEARCH_PARAM = {
    //     "historyofPresentIllnessType": defaultSelectedItems?.historyofPresentIllnessType  || "",
    // }
    // const [searchParamHPIT, setSearchParamHPIT] = useState(DEFAULT_SEARCH_PARAM)
    const [is, setIs] = useState(true);

    const DEFAULT_SEARCH_VALUE = {
        "historyofPresentIllnessType": DropdownValueHandler(historyofPresentIllnessTypeData, defaultSelectedItems?.historyofPresentIllnessType) || "",
        "reviewOfSystemType": DropdownValueHandler(historyofPresentIllnessTypeData, defaultSelectedItems?.reviewOfSystemType) || "",
    }
    const [searchValue, setSearchValue] = useState(DEFAULT_SEARCH_VALUE)

    const API_URL_GENERAL = enumUtil.controller.General;
    // const isTopOrBottom = insertPosition === 'Top' || insertPosition === 'Bottom';
    let NOTES_DATA = {
        SOAP: {
            allKeys: [
                // ...(isTopOrBottom ? ['customTemplateClinical'] : []),
                "patientSummary",
                "subjective",
                "chiefComplaint",
                "historyofPresentIllness",
                "reviewOfSystem",
                "subjectiveNotes",
                "objective",
                "vitals",
                "observations",
                "objectiveNotes",
                "assessment",
                "problems",
                "assessmentNotes",
                "plan",
                "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging",
                "planNotes",
                "followUp",
                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                // ...(isTopOrBottom ? { "customTemplateClinical": [] } : {}),
                subjective: [ "chiefComplaint", "historyofPresentIllness", "reviewOfSystem", "subjectiveNotes" ],
                objective: ["vitals", "observations", "objectiveNotes"],
                assessment: ["problems", "assessmentNotes"],
                plan: [ "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging", "planNotes", "followUp"],
                additionalInfo: ["documents", "additionalNotes"],
                procedureCodes: []
            }
        },
        GIRP: {
            allKeys: [
                "patientSummary",
                "chiefComplaint",
                "problems",
                "goalsNotes",
                "interventionNotes",
                "responseNotes",
                "planNotes",
                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                'patientSummary': [],
                'chiefComplaint': [],
                'problems': [],
                'goalsNotes': [],
                'interventionNotes': [],
                'responseNotes': [],
                'planNotes': [],
                'additionalInfo': ["documents", "additionalNotes"],
                'procedureCodes': []
            }
        },
        BIRP: {
            allKeys: [
                "patientSummary",
                "chiefComplaint",
                "problems",
                "behaviourNotes",
                "interventionNotes",
                "responseNotes",
                "planNotes",
                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                'patientSummary': [],
                'chiefComplaint': [],
                'problems': [],
                'behaviourNotes': [],
                'interventionNotes': [],
                'responseNotes': [],
                'planNotes': [],
                'additionalInfo': ["documents", "additionalNotes"],
                'procedureCodes': []
            }
        },
        DAPP: {
            allKeys: [
                "patientSummary",
                "chiefComplaint",
                "problems",
                "dataNotes",
                "interventionNotes",
                "assessmentNotes",
                "progressNotes",
                "planNotes",
                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                'patientSummary': [],
                'chiefComplaint': [],
                'problems': [],
                'dataNotes': [],
                'assessmentNotes': [],
                'progressNotes': [],
                'planNotes': [],
                'additionalInfo': ["documents", "additionalNotes"],
                'procedureCodes': []
            }
        },
        DAP: {
            allKeys: [
                "patientSummary",
                "chiefComplaint",
                "problems",
                "dataNotes",
                "interventionNotes",
                "assessmentNotes",
                "planNotes",
                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                'patientSummary': [],
                'chiefComplaint': [],
                'problems': [],
                'dataNotes': [],
                'assessmentNotes': [],
                'planNotes': [],
                'additionalInfo': ["documents", "additionalNotes"],
                'procedureCodes': []
            }
        },
        Other: {
            allKeys: [
                "patientSummary",
                "chiefComplaint",
                "vitals",
                "objectiveNotes",
                "problems",
                "otherNote",
                "followUp",
                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                'patientSummary': [],
                'chiefComplaint': [],
                'vitals': [],
                'problems': [],
                'otherNote': [],
                'followUp': [],
                'additionalInfo': ["documents", "additionalNotes"],
                'procedureCodes': [],
            }
        },
        Therapy: {
            allKeys: [
                "patientSummary",
                "chiefComplaint",
                "problems",
                "objective",
                "currentMentalStatus",
                "objectiveNotes",
                "intervention",
                "interventionNotes",
                "interventionsUsed",
                "response",
                "responseNotes",
                "responseObservations",
                "assessment",
                "riskAssessment",
                "assessmentNotes",
                "plan",
                "planNotes",

                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                'patientSummary': [],
                'chiefComplaint': [],
                'problems': [],
                'objective': ["currentMentalStatus", "objectiveNotes"],
                'intervention': ["interventionNotes", "interventionsUsed"],
                'response': ["responseNotes", "responseObservations"],
                'assessment': ["riskAssessment", "assessmentNotes"],
                'plan': ["planNotes"],
                'additionalInfo': ["documents", "additionalNotes"],
                'procedureCodes': []
            }
        },
        Massage: {
            allKeys: [
                "patientSummary",
                "chiefComplaint",
                "problems",
                "subjectiveNotes",
                "objective",
                "objectiveFindings",
                "objectiveNotes",
                "assessment",
                "assessmentAreaTreated", 
                "focusArea", 
                "assessmentMethodUsed",
                "assessmentNotes",
                "plan",
                "planNotes",
                "homeExerciseProgram",
                "followUp",
                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                'patientSummary': [],
                'chiefComplaint':[],
                'problems':[],
                'subjectiveNotes': [],
                'objective': ["objectiveFindings", "objectiveNotes"],
                'assessment': ["assessmentAreaTreated", "focusArea", "assessmentMethodUsed", "assessmentNotes"],
                'plan': ["planNotes", "homeExerciseProgram", "followUp"],
                'additionalInfo': ["documents", "additionalNotes"],
                'procedureCodes': []
            }
        },
        Physical: {
            allKeys: [
                "patientSummary",
                "chiefComplaint",
                "problems",
                "subjectiveNotes",
                "objective",
                "observationNotes", "problemArea", "palpationNotes", "rangeOfMotion", "strength", "testMeasurementNotes", "objectiveNotes",
                // "objectiveNotes",
                // "assessment",
                "assessmentNotes",
                "plan",
                "planNotes",
                "homeExerciseProgram",
                "followUp",
                "additionalInfo",
                "documents",
                "additionalNotes",
                "procedureCodes",
            ],
            checklistStructure: {
                'patientSummary': [],
                'chiefComplaint':[],
                'problems':[],
                'subjectiveNotes': [],
                'objective': ["observationNotes", "problemArea", "palpationNotes", "rangeOfMotion", "strength", "testMeasurementNotes", "objectiveNotes"],
                'assessmentNotes': [
                    // "assessmentNotes"
                ],
                'plan': ["planNotes", "homeExerciseProgram", "followUp"],
                'additionalInfo': ["documents", "additionalNotes"],
                'procedureCodes': []
            }
        },

    };

    const [selectedItems, setSelectedItems] = useState(defaultSelectedItems);
    const [isLoading, setIsLoading] = useState(false);

    console.log("NoteDisplaySettings defaultSelectedItems selectedItems", selectedItems);

    const handleSave = () => {
        if(!IsEditAllowed) return
        if(!IsEncounterProvider) return;
        let {uiDesign = false , NoteTypeSettingID, ...items} = { ...selectedItems };
        const convertedNoteItems = convertValsToStrings(items);
        console.log("SaveSelectedItems", convertedNoteItems, NoteTypeSettingID);
        setIsLoading(true);
        ServerRequestProtected(API_URL_GENERAL + "/SaveSingleRecord", 'post', {
            "TableName": enumUtil.enumAPITableName.NoteTypeSetting,
            "ID": NoteTypeSettingID || "0",
            "Data": {
                ...convertedNoteItems,
            },
        })
            .then((response) => {
                setIsNoteOpened(false);
                console.log("encounterNotesDisplaySettinghandleSave", allEncounterNotesDisplaySetting, selectedItems)
                // let allNotesSetts = { ...allEncounterNotesDisplaySetting,  [selectedItems?.NoteType] : selectedItems}

                const updatedAllNotesSettings = allEncounterNotesDisplaySetting.map(providerObj => {
                    if (providerObj.ProviderID !== selectedItems.ProviderID) return providerObj;
                    const exists = providerObj.Children.some(s => s.NoteType === selectedItems.NoteType);

                    return {
                        ...providerObj,
                        Children: exists
                            ? providerObj.Children.map(setting =>
                                setting.NoteType === selectedItems.NoteType
                                    ? { ...setting, ...selectedItems }
                                    : setting
                            ) : [...providerObj.Children, selectedItems],
                    };
                });
                dispatch(EncounterNotesDisplaySettings(updatedAllNotesSettings))
                // setDefaultSelectedItems?.(() => ({ ...selectedItems })); // set default new saved value in default note selection state (initially uses API values if available, otherwise defaults)
                // setPrintOutSelectedItems?.(() => ({ ...selectedItems })); // set default new saved value in note printout selection state.
                setIsLoading(false);
                NotificationHandler('Note Settings updated successfully.', enumUtil.enumtoaster.success)
            }).catch((error) => {
                setIsLoading(false);
            })
    }

    const checklistStructure = NOTES_DATA?.[noteType]?.checklistStructure;
    const allKeys = NOTES_DATA?.[noteType]?.allKeys;


    const getParentKey = (childKey) => {
        for (const [parent, children] of Object.entries(checklistStructure)) {
            if (children.includes(childKey)) return parent;
        }
        return null;
    };

    const toggleItem = (key) => {
        setSelectedItems((prev) => {
            const updated = { ...prev };
            const isNowChecked = !prev[key];

            // 1. Check if it's a parent
            if (checklistStructure[key]) {
                // Parent toggle: set parent and all children
                updated[key] = isNowChecked;
                checklistStructure[key].forEach((child) => {
                    updated[child] = isNowChecked;
                });
            } else {
                // 2. It's a child toggle
                updated[key] = isNowChecked;

                const parent = getParentKey(key);
                if (parent) {
                    const allChildren = checklistStructure[parent];
                    const allChecked = allChildren.every((c) =>
                        c === key ? isNowChecked : prev[c]
                    );
                    updated[parent] = allChecked;
                }
            }

            return updated;
        });
    };

    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...searchValue };
        let saveModal = { ...selectedItems };
        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display;
            saveModal[name] = selectedData.value + "";
        } else if (type === 'server' && !isNull(selectedData)) {
        } else {
            modal[name] = ''
            saveModal[name] = "";
        }
        setSearchValue(modal)
        setSelectedItems(saveModal);

        return selectedData
    }

    return (
        <>
            <Modal show={true} onHide={true} backdrop="static" keyboard={false} centered dialogClassName={`hk-modal-v1 ar_note_display_setting  ${['GIRP', 'Other'].includes(noteType)}`}>
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    <div className="d-flex align-items-center justify-content-between mb-12 px-10">
                        <div className="">
                            <p className="heading dark-clr fs-13 lh-normal">Note Display Settings</p>
                            <p className="text dark-clr fs-13 lh-normal">Customize your note view by modifying the settings below.</p>
                        </div>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={() => setIsNoteOpened(false)}></i>
                    </div>

                    {noteType === 'SOAP' &&
                        (
                            <div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">
                                {/* ///////////// Custom Tempalte Clinical ///////////// */}
                                {/* {isTopOrBottom ?
                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="heading fs-13">Clinical Custom Template</p>

                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div> : <></>} */}

                                <div className="">
                                    <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                        <p className="heading fs-13">Subjective</p>
                                    </div>
                                    <div className="d-flex flex-column gap-2">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Chief Complaint</p>
                                            <p className="text ar-light-color">Required</p>
                                        </div>

                                        <div className="d-flex justify-content-between">
                                            <p className="text">History of Present Illness</p>
                                            <div className="d-flex flex-column gap-1">
                                                <label className="custom_check_box d-flex align-items-center gap-6">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItems["historyofPresentIllness"]}
                                                        onChange={() => toggleItem("historyofPresentIllness")}
                                                    />
                                                    <p className="text fs-12 user-select-none">Show Section</p>
                                                </label>
                                                {selectedItems["historyofPresentIllness"] ?
                                                    <div className="w-100px">
                                                        <SuperSearchList
                                                            type="client"
                                                            id="historyofPresentIllnessType"
                                                            name="historyofPresentIllnessType"
                                                            searchValue={searchValue.historyofPresentIllnessType}
                                                            data={historyofPresentIllnessTypeData}
                                                            onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, historyofPresentIllnessType: e.target.value || null }) }}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            placeholder={false}
                                                        />
                                                    </div> : <></>}

                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Review of System</p>
                                            <div className="">
                                                <label className="custom_check_box d-flex align-items-center gap-6">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        // name='IsAutoSubmittion'
                                                        // id='IsAutoSubmittion'
                                                        checked={!!selectedItems["reviewOfSystem"]}
                                                        onChange={() => toggleItem("reviewOfSystem")}
                                                    />
                                                    <p className="text fs-12 user-select-none">Show Section</p>
                                                </label>
                                                {selectedItems["reviewOfSystem"] ?
                                                    <div className="w-100px">
                                                        <SuperSearchList
                                                            type="client"
                                                            id="reviewOfSystemType"
                                                            name="reviewOfSystemType"
                                                            searchValue={searchValue.reviewOfSystemType}
                                                            data={historyofPresentIllnessTypeData}
                                                            onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, reviewOfSystemType: e.target.value || null }) }}
                                                            getSelectedData={handleSelectedData}
                                                            is={is}
                                                            icon={'Simple'}
                                                            sup_btn='sup_btn'
                                                            sup_inp='superSearchVisitInp'
                                                            placeholder={false}
                                                        />
                                                    </div> : <></>}
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Notes</p>
                                            <div className="">
                                                <label className="custom_check_box d-flex align-items-center gap-6">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        // name='IsAutoSubmittion'
                                                        // id='IsAutoSubmittion'
                                                        checked={!!selectedItems["subjectiveNotes"]}
                                                        onChange={() => toggleItem("subjectiveNotes")}
                                                    />
                                                    <p className="text fs-12 user-select-none">Show Section</p>
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="">
                                    <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                        <p className="heading fs-13">Objective</p>
                                    </div>
                                    <div className="d-flex flex-column gap-2">

                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Vitals</p>
                                            <div className="">
                                                <label className="custom_check_box d-flex align-items-center gap-6">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        checked={!!selectedItems["vitals"]}
                                                        onChange={() => toggleItem("vitals")}
                                                    />
                                                    <p className="text fs-12 user-select-none">Show Section</p>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Observations</p>
                                            <div className="">
                                                <label className="custom_check_box d-flex align-items-center gap-6">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        // name='IsAutoSubmittion'
                                                        // id='IsAutoSubmittion'
                                                        checked={!!selectedItems["observations"]}
                                                        onChange={() => toggleItem("observations")}
                                                    />
                                                    <p className="text fs-12 user-select-none">Show Section</p>
                                                </label>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Notes</p>
                                            <p className="text ar-light-color">Required</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="">
                                    <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                        <p className="heading fs-13">Assessment</p>
                                    </div>
                                    <div className="d-flex flex-column gap-2">

                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Problems</p>
                                            <div className="">
                                                <label className="custom_check_box d-flex align-items-center gap-6">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        // name='IsAutoSubmittion'
                                                        // id='IsAutoSubmittion'
                                                        checked={!!selectedItems["problems"]}
                                                        onChange={() => toggleItem("problems")}
                                                    />
                                                    <p className="text fs-12 user-select-none">Show Section</p>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Notes</p>
                                            <p className="text ar-light-color">Required</p>
                                        </div>
                                    </div>
                                </div>


                                <div className="">
                                    <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                        <p className="heading fs-13">Plan</p>
                                    </div>
                                    <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                    <p className="text">Prescriptions</p>
                                    <div className="">
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["prescriptions"]}
                                                onChange={() => toggleItem("prescriptions")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="text">Supplements</p>
                                    <div className="">
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["supplements"]}
                                                onChange={() => toggleItem("supplements")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="text">Vaccines</p>
                                    <div className="">
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["vaccines"]}
                                                onChange={() => toggleItem("vaccines")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="text">Injections</p>
                                    <div className="">
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["injections"]}
                                                onChange={() => toggleItem("injections")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="text">Labs</p>
                                    <div className="">
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["labs"]}
                                                onChange={() => toggleItem("labs")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="text">Imaging</p>
                                    <div className="">
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["imaging"]}
                                                onChange={() => toggleItem("imaging")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="text">Notes</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>

                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="text">Follow-Up</p>
                                    <div className="">
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["followUp"]}
                                                onChange={() => toggleItem("followUp")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div>
                                    </div>
                                </div>

                                <div className="">
                                    <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                        <p className="heading fs-13">Additional Info</p>
                                    </div>
                                    <div className="d-flex flex-column gap-2">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Documents</p>
                                            <div className="">
                                                <label className="custom_check_box d-flex align-items-center gap-6">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        // name='IsAutoSubmittion'
                                                        // id='IsAutoSubmittion'
                                                        checked={!!selectedItems["documents"]}
                                                        onChange={() => toggleItem("documents")}
                                                    />
                                                    <p className="text fs-12 user-select-none">Show Section</p>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                            <p className="text">Notes</p>
                                            <div className="">
                                                <label className="custom_check_box d-flex align-items-center gap-6">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input m-0 p-0"
                                                        // name='IsAutoSubmittion'
                                                        // id='IsAutoSubmittion'
                                                        checked={!!selectedItems["additionalNotes"]}
                                                        onChange={() => toggleItem("additionalNotes")}
                                                    />
                                                    <p className="text fs-12 user-select-none">Show Section</p>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="heading fs-13">Quality of Care</p>

                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["qualityOfCare"]}
                                                onChange={() => toggleItem("qualityOfCare")}
                                            />
                                            <p className="text fs-12 user-select-none">Show Section</p>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        )}

                    {noteType === 'GIRP' &&
                        (<div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Chief Complaint</p>
                                    <p className="text ar-light-color">Required</p>

                                    {/* <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["chiefComplaint"]}
                                            onChange={() => toggleItem("chiefComplaint")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label> */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p className="heading fs-13">History of Present Illness</p>
                                <div className="d-flex flex-column gap-1">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["historyofPresentIllness"]}
                                            onChange={() => toggleItem("historyofPresentIllness")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["historyofPresentIllness"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="historyofPresentIllnessType"
                                                name="historyofPresentIllnessType"
                                                searchValue={searchValue.historyofPresentIllnessType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, historyofPresentIllnessType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}

                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                                <p className="heading fs-13">Review of System</p>
                                <div className="">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            // name='IsAutoSubmittion'
                                            // id='IsAutoSubmittion'
                                            checked={!!selectedItems["reviewOfSystem"]}
                                            onChange={() => toggleItem("reviewOfSystem")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["reviewOfSystem"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="reviewOfSystemType"
                                                name="reviewOfSystemType"
                                                searchValue={searchValue.reviewOfSystemType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, reviewOfSystemType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Problems</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["problems"]}
                                            onChange={() => toggleItem("problems")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Goals</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Intervention</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Response</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Plan</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Prescriptions</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Supplements</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Vaccines</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Injections</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Labs</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Imaging</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Follow-Up</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Additional Info</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Documents</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Quality of Care</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["qualityOfCare"]}
                                            onChange={() => toggleItem("qualityOfCare")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                        </div>)}

                    {noteType === 'BIRP' &&
                        (<div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Chief Complaint</p>
                                    <p className="text ar-light-color">Required</p>

                                    {/* <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["chiefComplaint"]}
                                            onChange={() => toggleItem("chiefComplaint")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label> */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p className="heading fs-13">History of Present Illness</p>
                                <div className="d-flex flex-column gap-1">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["historyofPresentIllness"]}
                                            onChange={() => toggleItem("historyofPresentIllness")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["historyofPresentIllness"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="historyofPresentIllnessType"
                                                name="historyofPresentIllnessType"
                                                searchValue={searchValue.historyofPresentIllnessType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, historyofPresentIllnessType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}

                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                                <p className="heading fs-13">Review of System</p>
                                <div className="">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            // name='IsAutoSubmittion'
                                            // id='IsAutoSubmittion'
                                            checked={!!selectedItems["reviewOfSystem"]}
                                            onChange={() => toggleItem("reviewOfSystem")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["reviewOfSystem"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="reviewOfSystemType"
                                                name="reviewOfSystemType"
                                                searchValue={searchValue.reviewOfSystemType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, reviewOfSystemType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Problems</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["problems"]}
                                            onChange={() => toggleItem("problems")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Behaviour</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Intervention</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Response</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Plan</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Prescriptions</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Supplements</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Vaccines</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Injections</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Labs</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Imaging</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Follow-Up</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Additional Info</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Documents</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Quality of Care</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["qualityOfCare"]}
                                            onChange={() => toggleItem("qualityOfCare")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                        </div>)}

                    {noteType === 'DAP' &&
                        (<div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Chief Complaint</p>
                                    <p className="text ar-light-color">Required</p>

                                    {/* <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["chiefComplaint"]}
                                            onChange={() => toggleItem("chiefComplaint")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label> */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p className="heading fs-13">History of Present Illness</p>
                                <div className="d-flex flex-column gap-1">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["historyofPresentIllness"]}
                                            onChange={() => toggleItem("historyofPresentIllness")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["historyofPresentIllness"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="historyofPresentIllnessType"
                                                name="historyofPresentIllnessType"
                                                searchValue={searchValue.historyofPresentIllnessType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, historyofPresentIllnessType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}

                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                                <p className="heading fs-13">Review of System</p>
                                <div className="">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            // name='IsAutoSubmittion'
                                            // id='IsAutoSubmittion'
                                            checked={!!selectedItems["reviewOfSystem"]}
                                            onChange={() => toggleItem("reviewOfSystem")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["reviewOfSystem"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="reviewOfSystemType"
                                                name="reviewOfSystemType"
                                                searchValue={searchValue.reviewOfSystemType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, reviewOfSystemType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Problems</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["problems"]}
                                            onChange={() => toggleItem("problems")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Data</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Assessment</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Plan</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Prescriptions</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Supplements</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Vaccines</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Injections</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Labs</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Imaging</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Follow-Up</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Additional Info</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Documents</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Quality of Care</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["qualityOfCare"]}
                                            onChange={() => toggleItem("qualityOfCare")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                        </div>)}
                    
                    {noteType === 'DAPP' &&
                        (<div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Chief Complaint</p>
                                    <p className="text ar-light-color">Required</p>

                                    {/* <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["chiefComplaint"]}
                                            onChange={() => toggleItem("chiefComplaint")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label> */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p className="heading fs-13">History of Present Illness</p>
                                <div className="d-flex flex-column gap-1">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["historyofPresentIllness"]}
                                            onChange={() => toggleItem("historyofPresentIllness")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["historyofPresentIllness"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="historyofPresentIllnessType"
                                                name="historyofPresentIllnessType"
                                                searchValue={searchValue.historyofPresentIllnessType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, historyofPresentIllnessType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}

                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                                <p className="heading fs-13">Review of System</p>
                                <div className="">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            // name='IsAutoSubmittion'
                                            // id='IsAutoSubmittion'
                                            checked={!!selectedItems["reviewOfSystem"]}
                                            onChange={() => toggleItem("reviewOfSystem")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["reviewOfSystem"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="reviewOfSystemType"
                                                name="reviewOfSystemType"
                                                searchValue={searchValue.reviewOfSystemType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, reviewOfSystemType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Problems</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["problems"]}
                                            onChange={() => toggleItem("problems")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Data</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Assessment</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Progress</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Plan</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Prescriptions</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Supplements</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Vaccines</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Injections</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Labs</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Imaging</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Follow-Up</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Additional Info</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Documents</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Quality of Care</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["qualityOfCare"]}
                                            onChange={() => toggleItem("qualityOfCare")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                        </div>)}

                    {noteType === 'Other' &&
                        (<div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Chief Complaint</p>
                                    <p className="text ar-light-color">Required</p>

                                    {/* <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["chiefComplaint"]}
                                            onChange={() => toggleItem("chiefComplaint")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label> */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p className="heading fs-13">History of Present Illness</p>
                                <div className="d-flex flex-column gap-1">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["historyofPresentIllness"]}
                                            onChange={() => toggleItem("historyofPresentIllness")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["historyofPresentIllness"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="historyofPresentIllnessType"
                                                name="historyofPresentIllnessType"
                                                searchValue={searchValue.historyofPresentIllnessType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, historyofPresentIllnessType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}

                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                                <p className="heading fs-13">Review of System</p>
                                <div className="">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            // name='IsAutoSubmittion'
                                            // id='IsAutoSubmittion'
                                            checked={!!selectedItems["reviewOfSystem"]}
                                            onChange={() => toggleItem("reviewOfSystem")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["reviewOfSystem"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="reviewOfSystemType"
                                                name="reviewOfSystemType"
                                                searchValue={searchValue.reviewOfSystemType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, reviewOfSystemType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Vitals</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            // name='IsAutoSubmittion'
                                            // id='IsAutoSubmittion'
                                            checked={!!selectedItems["vitals"]}
                                            onChange={() => toggleItem("vitals")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Problems</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["problems"]}
                                            onChange={() => toggleItem("problems")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Other Note</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>

                            {/* <div className="">
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="heading fs-13">Follow-Up</p>

                            <label className="custom_check_box d-flex align-items-center gap-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    checked={!!selectedItems["followUp"]}
                                    onChange={() => toggleItem("followUp")}
                                />
                                <p className="text fs-12 user-select-none">Show Section</p>
                            </label>
                        </div>
                    </div> */}

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Follow-Up</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["followUp"]}
                                            onChange={() => toggleItem("followUp")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                            
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Additional Info</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Documents</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Quality of Care</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["qualityOfCare"]}
                                            onChange={() => toggleItem("qualityOfCare")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                        </div>)}

                    {noteType === 'Therapy' &&
                        (<div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Chief Complaint</p>
                                    <p className="text ar-light-color">Required</p>

                                    {/* <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["chiefComplaint"]}
                                            onChange={() => toggleItem("chiefComplaint")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label> */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <p className="heading fs-13">History of Present Illness</p>
                                <div className="d-flex flex-column gap-1">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["historyofPresentIllness"]}
                                            onChange={() => toggleItem("historyofPresentIllness")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["historyofPresentIllness"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="historyofPresentIllnessType"
                                                name="historyofPresentIllnessType"
                                                searchValue={searchValue.historyofPresentIllnessType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, historyofPresentIllnessType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}

                                </div>
                            </div>

                            <div className="d-flex align-items-center justify-content-between">
                                <p className="heading fs-13">Review of System</p>
                                <div className="">
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            // name='IsAutoSubmittion'
                                            // id='IsAutoSubmittion'
                                            checked={!!selectedItems["reviewOfSystem"]}
                                            onChange={() => toggleItem("reviewOfSystem")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                    {selectedItems["reviewOfSystem"] ?
                                        <div className="w-100px">
                                            <SuperSearchList
                                                type="client"
                                                id="reviewOfSystemType"
                                                name="reviewOfSystemType"
                                                searchValue={searchValue.reviewOfSystemType}
                                                data={historyofPresentIllnessTypeData}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, reviewOfSystemType: e.target.value || null }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                placeholder={false}
                                            />
                                        </div> : <></>}
                                </div>
                            </div>
                            
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Problems</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["problems"]}
                                            onChange={() => toggleItem("problems")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Objective</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Current Mental Status</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["currentMentalStatus"]}
                                                    onChange={() => toggleItem("currentMentalStatus")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Interventions</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Interventions Used</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["interventionsUsed"]}
                                                    onChange={() => toggleItem("interventionsUsed")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Response</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Response Observations</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["responseObservations"]}
                                                    onChange={() => toggleItem("responseObservations")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Assessment</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Risk Assessment</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["riskAssessment"]}
                                                    onChange={() => toggleItem("riskAssessment")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Plan</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Prescriptions</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Supplements</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Vaccines</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Injections</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Labs</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Imaging</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Follow-Up</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Additional Info</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Documents</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Quality of Care</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["qualityOfCare"]}
                                            onChange={() => toggleItem("qualityOfCare")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                        </div>)}

                    {noteType === 'Massage' &&
                        (<div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Chief Complaint</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Problems</p>
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["problems"]}
                                            onChange={() => toggleItem("problems")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Subjective</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Objective</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Objective Findings</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["objectiveFindings"]}
                                                    onChange={() => toggleItem("objectiveFindings")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Assessment</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Areas Treated</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["assessmentAreaTreated"]}
                                                    onChange={() => toggleItem("assessmentAreaTreated")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Focus Area</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["focusArea"]}
                                                    onChange={() => toggleItem("focusArea")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Methods Used</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["assessmentMethodUsed"]}
                                                    onChange={() => toggleItem("assessmentMethodUsed")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Response</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Response Observations</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["responseObservations"]}
                                                    onChange={() => toggleItem("responseObservations")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Assessment</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Risk Assessment</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    // name='IsAutoSubmittion'
                                                    // id='IsAutoSubmittion'
                                                    checked={!!selectedItems["riskAssessment"]}
                                                    onChange={() => toggleItem("riskAssessment")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                </div>
                            </div> */}

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Plan</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Home Exercise Program(HEP)</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["homeExerciseProgram"]}
                                                    onChange={() => toggleItem("homeExerciseProgram")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Follow-Up</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Additional Info</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Documents</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Quality of Care</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["qualityOfCare"]}
                                            onChange={() => toggleItem("qualityOfCare")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                        </div>)}
                    {noteType === 'Physical' &&
                        (<div className="d-flex flex-column gap-12 scroll-content hover-scrollbar">
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Chief Complaint</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Problems</p>
                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["problems"]}
                                            onChange={() => toggleItem("problems")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Subjective</p>
                                    <p className="text ar-light-color">Required</p>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Objective</p>
                                </div>
                                <div className="d-flex flex-column gap-2">

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Observations</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["observationNotes"]}
                                                    onChange={() => toggleItem("observationNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Problem Area</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["problemArea"]}
                                                    onChange={() => toggleItem("problemArea")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Palpation</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["palpationNotes"]}
                                                    onChange={() => toggleItem("palpationNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Range of Motion</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["rangeOfMotion"]}
                                                    onChange={() => toggleItem("rangeOfMotion")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Strength</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["strength"]}
                                                    onChange={() => toggleItem("strength")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Tests & Measurements</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["testMeasurementNotes"]}
                                                    onChange={() => toggleItem("testMeasurementNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Assessment</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Plan</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <p className="text ar-light-color">Required</p>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Home Exercise Program(HEP)</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["homeExerciseProgram"]}
                                                    onChange={() => toggleItem("homeExerciseProgram")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Follow-Up</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="br-bottom-1 za_br_light pb-1-5 mb-06-px">
                                    <p className="heading fs-13">Additional Info</p>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Documents</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="text">Notes</p>
                                        <div className="">
                                            <label className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                                <p className="text fs-12 user-select-none">Show Section</p>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="heading fs-13">Quality of Care</p>

                                    <label className="custom_check_box d-flex align-items-center gap-6">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["qualityOfCare"]}
                                            onChange={() => toggleItem("qualityOfCare")}
                                        />
                                        <p className="text fs-12 user-select-none">Show Section</p>
                                    </label>
                                </div>
                            </div>
                        </div>)}

            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={() => setIsNoteOpened(false)}>Cancel</button>
                <button className={`btn btn-validate px-10 h-100 ${(!IsEditAllowed || !IsEncounterProvider) ?  'disable' : ''}`} onClick={handleSave}>Save </button>
            </div>
        </Modal>
    </>
  )
}

export default NoteDisplaySettings